import {
  Injectable,
  Injector,
  ComponentFactoryResolver,
  EmbeddedViewRef,
  ApplicationRef
} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DomElementService {

  constructor(
    private componentFactoryResolver: ComponentFactoryResolver,
    private appRef: ApplicationRef,
    private injector: Injector
  ) { }

  public appendComponent(element: any, component: any, inputs: any) {
    // Create a component reference from the component
    const componentRef = this.componentFactoryResolver
      .resolveComponentFactory(component)
      .create(this.injector);

    Object.keys(inputs).forEach(function(key) {
      componentRef.instance[key] = inputs[key];
    });

    // Attach component to the appRef so that it's inside the ng component tree
    this.appRef.attachView(componentRef.hostView);

    // Get DOM element from component
    const domElem = (componentRef.hostView as EmbeddedViewRef<any>)
      .rootNodes[0] as HTMLElement;

    // Append DOM element to the element
    element.appendChild(domElem);

    // Wait some time and remove it from the component tree and from the DOM
    // setTimeout(() => {
    //   this.appRef.detachView(componentRef.hostView);
    //   componentRef.destroy();
    // }, 3000);
  }

  getSiblings(el: HTMLElement): HTMLElement[] {
    let next = el, prev = el, siblings = [];
    while (next = next.nextSibling as HTMLElement) {
      siblings.push(next);
    }
    while (prev = prev.previousSibling as HTMLElement) {
      siblings.push(prev);
    }
    return siblings;
  }
}
